var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _c('section', [_c('error-messages', {
    attrs: {
      "error": _vm.hasError,
      "error-unauthenticated": _vm.pleaseLoginAgain,
      "error-empty": !_vm.dispatchRequests.length,
      "error-not-found": _vm.salesOrderNotFound,
      "is-order-from-today": _vm.isOrderFromToday
    }
  }), _vm.isSaveSuccessful === true ? _c('alert', {
    attrs: {
      "success": ""
    },
    on: {
      "close": _vm.closeAlert
    }
  }, [_vm._v(" De gevraagde leveringsverzoeken zijn geannuleerd. ")]) : _vm._e(), _vm.isSaveSuccessful === false ? _c('alert', {
    on: {
      "close": _vm.closeAlert
    }
  }, [_vm._v(" Er is iets mis gegaan bij het aanvragen van de annuleringen. ")]) : _vm._e(), _vm._l(_vm.dispatchRequests, function (dispatchRequest) {
    return _c('b-card', {
      key: dispatchRequest.id,
      staticClass: "mb-4"
    }, [_c('b-card-title', [_c('h5', [_c('dispatch-request-status', {
      attrs: {
        "status": dispatchRequest.status
      }
    }), _vm._v(" (via "), _c('dispatcher-type', {
      attrs: {
        "type": dispatchRequest.dispatcher_type,
        "name": dispatchRequest.dispatcher_identifier
      }
    }), _vm._v(" , leveringsverzoek " + _vm._s(dispatchRequest.id) + ") ")], 1), _c('table', {
      staticClass: "generic"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "width": "150px"
      }
    }, [_c('small', [_c('strong', [_vm._v("Laatste update:")])])]), _c('td', [_c('small', [_vm._v(_vm._s(_vm._f("datetime")(dispatchRequest.updated_at)))])])]), _c('tr', [_c('th', [_c('small', [_c('strong', [_vm._v("Leverdatum:")])])]), _c('td', [_c('small', [_vm._v(_vm._s(_vm._f("date")(dispatchRequest.dispatch_date)))])])]), _c('tr', [_c('th', [_c('small', [_c('strong', [_vm._v("Type:")])])]), _c('td', [_c('small', [_vm._v(_vm._s(dispatchRequest.dispatch_type))])])]), _c('tr', [_c('th', [_c('small', [_c('strong', [_vm._v("Vervoerder:")])])]), _c('td', [_c('small', [_vm._v(_vm._s(dispatchRequest.carrier.display_name))])])]), _c('tr', [_c('th', [_c('small', [_c('strong', [_vm._v("Vervoersmethode:")])])]), _c('td', [_c('small', [_vm._v(_vm._s(dispatchRequest.carrier_method.display_name))])])])])]), _c('b-table-simple', {
      staticClass: "generic"
    }, [_c('colgroup', [_c('col', {
      attrs: {
        "width": "10%"
      }
    }), _c('col', {
      attrs: {
        "width": "auto"
      }
    }), _c('col', {
      attrs: {
        "width": "10%"
      }
    }), _c('col', {
      attrs: {
        "width": "10%"
      }
    })]), _c('thead', [_c('tr', [_c('th', [_vm._v("Artikel nr.")]), _c('th', [_vm._v("Productnaam")]), _c('th', [_vm._v("Aantal")]), _c('th', [_vm._v("Annuleren")])])]), _c('tbody', _vm._l(dispatchRequest.lines, function (product) {
      return _c('tr', {
        key: product.product_identifier
      }, [_c('td', [_vm._v(_vm._s(product.product_identifier))]), _c('td', [_vm._v(_vm._s(product.product_name))]), _c('td', [_vm._v(_vm._s(product.quantity))]), _c('td', [dispatchRequest.is_cancellable ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: product.quantity_to_cancel,
          expression: "product.quantity_to_cancel"
        }],
        attrs: {
          "type": "number",
          "min": "0",
          "max": product.quantity,
          "disabled": _vm.isSaving
        },
        domProps: {
          "value": product.quantity_to_cancel
        },
        on: {
          "input": function ($event) {
            if ($event.target.composing) return;
            _vm.$set(product, "quantity_to_cancel", $event.target.value);
          }
        }
      }) : dispatchRequest.status === 'cancelled' ? _c('small', [_vm._v("Al geannuleerd")]) : _c('small', [_vm._v("Niet mogelijk")])])]);
    }), 0)])], 1);
  }), _vm.dispatchRequests.length ? _c('div', {
    staticClass: "clearfix"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.isSubmitDisabled
    },
    on: {
      "click": _vm.submitCancellation
    }
  }, [!_vm.isSaving ? _c('span', [_vm._v("Annuleringen opslaan")]) : _c('span', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }